// components/StatCard.jsx
import { Box, Card, CardContent, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';

const StatCard = ({ stat, index }) => {
  // Card variant animation
  const cardVariant = {
    hover: {
      scale: 1.05,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 15,
      },
    },
  };

  // Floating animation for icon
  const floatingAnimation = {
    y: [0, -10, 0],
    transition: {
      duration: 3,
      repeat: Infinity,
      ease: 'easeInOut',
    },
  };

  return (
    <motion.div whileHover="hover" variants={cardVariant}>
      <Card
        sx={{
          height: '100%',
          borderRadius: 3,
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
          border: '1px solid rgba(18, 155, 171, 0.2)',
          background: '#fff',
        }}
      >
        <CardContent>
          {/* Top colorful bar */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 6,
              background: stat.color,
            }}
          />
          
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              pt: 1,
            }}
          >
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  color: '#555',
                  mb: 1,
                }}
              >
                {stat.title}
              </Typography>

              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  delay: 0.3 + index * 0.1,
                  type: 'spring',
                  stiffness: 100,
                }}
              >
                <Typography
                  variant="h3"
                  component="div"
                  sx={{
                    fontWeight: 700,
                    fontSize: '2.5rem',
                    color: stat.color,
                    lineHeight: 1,
                  }}
                >
                  {stat.count}
                </Typography>
              </motion.div>
            </Box>

            <motion.div animate={floatingAnimation}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  background: stat.color,
                  p: 1.5,
                  borderRadius: '50%',
                  boxShadow: `0 4px 8px rgba(18, 155, 171, 0.3)`,
                }}
              >
                {stat.icon}
              </Box>
            </motion.div>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default StatCard;